(function () {
	'use strict';

	angular
		.module('expo-cupom-digital.services')
		.service('HelperService', HelperService)

	/** @ngInject */
	function HelperService($timeout, $state, $rootScope, NotifyService, ROUTES) {
		const HelperService = {
			handleOnRun,
			handleStateChangeStart,
			handleStateChangeSuccess,
			handleStateChangeError,
			handleViewContentLoaded,
			tryParseJSON,
			errorCallback,
			successCallback,
			startLoading,
			stopLoading,
			setErrorMessageForm,
			removeErrorMessageForm,
			getValidationMessage,
			convertToSlug,
			isScreenSmaller,
			scrollTo,
			getArrayByObject,
			getCookie,
			clearLocalStorageData,
			caminhoPastaImagem,
			getUserLocation,
			showHidePwd
		};

		return HelperService;

		function showHidePwd(element) {
			var input = document.getElementById(element);
			var inputBtn = document.getElementById(element + 'Btn');

			input.type = (input.type === "password") ? "text" : "password";

			if (input.type == "password") {
				inputBtn.classList.remove("bi-eye-slash-fill");
				inputBtn.classList.add("bi-eye-fill");
			}

			if (input.type == "text") {
				inputBtn.classList.remove("bi-eye-fill");
				inputBtn.classList.add("bi-eye-slash-fill");
			}
		}

		function getUserLocation(callback = "success") {
			console.log('callback: ', callback);
			let response;
			let options = {
				enableHighAccuracy: true,
				timeout: 5000,
				maximumAge: 30000
			};

			navigator.geolocation.getCurrentPosition(function (position) {
				console.log('position: ', position);
				if (callback == "success")
					response = position;
			}, function (error) {
				console.log('error: ', error);
				if (callback == "error")
					response = error;
			}, options);

			console.log('response: ', response);
			return response;
		}

		function caminhoPastaImagem(area, id, arquivo) {
			return `${ROUTES.API}/assets/uploads/${arquivo}`;
		}

		/**
		 * Auxiliar method executed when the system is starting
		 */
		function handleOnRun() {
			$rootScope.removeMessage = removeErrorMessageForm;
			$rootScope.isMobile = isScreenSmaller(767);
			$rootScope.currentYear = moment().format('YYYY');
			$rootScope.showEbookModal = false;
		}

		/**
		 * Auxiliar method to execute the necessary methods on the route change start
		 *
		 * @param {object} transition - The executing transition
		 */
		function handleStateChangeStart(transition) {

			return transition;
		}

		/**
		 * Auxiliar method executed on every route state successfull change
		 */
		function handleStateChangeSuccess() {

		}

		/**
		 * Auxiliar method executed when the route change fails
		 *
		 * @param {object} error - The transition error
		 */
		function handleStateChangeError(error) {
			if (error && error.redirTo)
				$state.go(error.redirTo);
		}

		/**
		 * Auxiliar method executed once the system has finished loading all of it's content
		 */
		function handleViewContentLoaded() {
			AOS.init();
		}

		/**
		 * Tries to parse a JSON string
		 *
		 * @param {string} jsonString - String to be parsed
		 */
		function tryParseJSON(jsonString) {
			try {
				var o = JSON.parse(jsonString);

				// Handle non-exception-throwing cases:
				// Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
				// but... JSON.parse(null) returns null, and typeof null === "object",
				// so we must check for that, too. Thankfully, null is falsey, so this suffices:
				if (o && typeof o === 'object')
					return o;
			} catch (e) {
				return false;
			}

			return false;
		}

		function errorCallback(error) {
			console.log('error: ', error);
			let message = 'Ocorreu um erro inesperado, por favor tente novamente.';

			if (error.data)
				error = error.data;

			if (error && error.Error && error.Message)
				message = error.Message;

			if (error && error.errors && error.errors.type && error.errors.message)
				message = error.errors.message;

			NotifyService.error('ERRO!', message);
		}

		function successCallback(type = 'create') {
			let message = '';

			if (type == 'create')
				message = 'Registro salvo com sucesso.';

			else if (type == 'update')
				message = 'Registro atualizado com sucesso.';

			else if (type == 'delete')
				message = 'Registro apagado com sucesso.';

			NotifyService.success('SUCESSO!', message);
		}

		function startLoading(element, message = null, isFullScreen = false) {
			$timeout(() => {
				let widget = $(element).closest('[data-widget]');

				if ($(element).attr('[data-widget]'))
					widget = $(element);

				const loadingBody = document.createElement('div');

				if (isFullScreen == true)
					loadingBody.className = 'loading-body full'
				else
					loadingBody.className = 'loading-body';

				const loadingContent = document.createElement('div');
				loadingContent.className = 'loading-content';

				$(loadingContent).append(`<img src="/app/dist/images/progress-dot-white.svg" alt="Carregando, aguarde..." />`);

				if (message)
					$(loadingContent).append(`<p>${message}</p>`);

				loadingBody.appendChild(loadingContent);

				widget.append(loadingBody);
			})
		}

		function stopLoading(element) {
			$timeout(() => {
				let widget = $(element).closest('[data-widget]');

				if ($(element).attr('[data-widget]'))
					widget = $(element);

				widget
					.find('.loading-body')
					.fadeOut(function () {
						$(this).remove();
					});
			})
		}

		function setErrorMessageForm(input, message) {
			let errorMessage = 'Este campo é obrigatório';

			if (message)
				errorMessage = message;

			if (!$(input).parent().find('.validationMessage').length) {
				$(input).parent()
					.append(`<label class=\'control-label has-error validationMessage\'>${errorMessage}</label>`);

				$(input)
					.addClass('has-error')
					.parents('.form-group')
					.addClass('has-error');
			}

			$([document.documentElement, document.body]).animate({
				scrollTop: $(input).offset().top - ($('.header').outerHeight() + 30)
			}, 600);
		}

		function removeErrorMessageForm(input) {
			$(input)
				.parent()
				.find('.validationMessage')
				.remove();

			$(input)
				.removeClass('has-error')
				.parents('.form-group')
				.removeClass('has-error');
		}

		function getValidationMessage(type) {
			var messages = {
				required: 'Este campo é obrigatório',
				email: 'Por favor, forneça um endereço de email válido',
				date: 'Por favor, forneça uma data válida',
				phone: 'Por favor, forneça um telefone válido',
				number: 'Por favor, forneça um número válido',
				cpf: 'Por favor, forneça um cpf válido',
				cnpj: 'Por favor, forneça um cnpj válido',
				url: 'Por favor, forneça uma url válida',
				name: 'Por favor, forneça um nome válido',
				lastName: 'Por favor, forneça um sobrenome válido',
				passNotMatch: 'As senhas não combinam',
				passTooSmall: 'A senha deve conter ao menos 8 caracteres',
				passNoUpper: 'A senha deve conter ao menos um caracter maiúsculo',
				passNoNumeric: 'A senha deve conter ao menos um caracter numérico'
			};

			return messages[type];
		}

		function convertToSlug(str) {
			const a = 'àáäâãåăæąçćčđďèéěėëêęğǵḧìíïîįłḿǹńňñòóöôœøṕŕřßşśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;'
			const b = 'aaaaaaaaacccddeeeeeeegghiiiiilmnnnnooooooprrsssssttuuuuuuuuuwxyyzzz------'
			const p = new RegExp(a.split('').join('|'), 'g')

			return str.toString().toLowerCase()
				.replace(/\s+/g, '-') // Replace spaces with -
				.replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
				.replace(/&/g, '-and-') // Replace & with 'and'
				.replace(/[^\w-]+/g, '') // Remove all non-word characters
				.replace(/--+/g, '-') // Replace multiple - with single -
				.replace(/^-+/, '') // Trim - from start of text
				.replace(/-+$/, '') // Trim - from end of text
		}

		function isScreenSmaller(size) {
			return Modernizr.mq(`(max-width: ${size}px)`);
		}

		function scrollTo(navTo) {
			if ($rootScope.isMobile) {
				$('html, body').animate({
					scrollTop: ($(navTo).offset().top - ($('.navbar').outerHeight()) + 210)
				}, 600);
			} else {
				$('html, body').animate({
					scrollTop: ($(navTo).offset().top - ($('.navbar').outerHeight()) + 10)
				}, 600);
			}
		}

		function getArrayByObject(object) {
			return Object.entries(object);
		}

		function getCookie(cname) {
			let name = cname + "=";
			let decodedCookie = decodeURIComponent(document.cookie);
			let ca = decodedCookie.split(';');

			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) == ' ')
					c = c.substring(1);

				if (c.indexOf(name) == 0)
					return c.substring(name.length, c.length);
			}

			return "";
		}

		function clearLocalStorageData(keyName) {
			if (localStorage.getItem(keyName))
				localStorage.removeItem(keyName)
		}
	}
}());